export enum PerfilEnum {
  GESTOR_ESTADUAL = 3,
  GESTOR_MUNICIPAL = 4,
  USUARIO_MUNICIPAL = 99,
  GESTOR_DSEI = 13,
}
